/**
 * Checklist CRUD — backed by /api/checklist.
 */
import { useCrudCollection } from './useCrudCollection';

export function useChecklist() {
  const crud = useCrudCollection({ basePath: 'checklist' });
  return {
    checklist: crud.items,
    setChecklist: crud.setItems,
    fetchChecklist: crud.fetch,
    createChecklistItem: crud.create,
    updateChecklistItem: crud.update,
    deleteChecklistItem: crud.remove,
  };
}
